import React, { useRef, useEffect } from 'react';
import styles from './style.module.scss';
import DropDown from '../../../../../components/DropDown/DropDown';
import KebabIcon from '../../../../../assets/svg/icons/common/kebab';
import useEmsOfficeStore from '../../../../../stores/ems-office';

const HighRiskIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M14.8001 11.7556L9.33444 2.26373C9.19785 2.03118 9.00287 1.83837 8.76881 1.70439C8.53476 1.57042 8.26975 1.49994 8.00006 1.49994C7.73037 1.49994 7.46536 1.57042 7.23131 1.70439C6.99725 1.83837 6.80227 2.03118 6.66569 2.26373L1.20006 11.7556C1.06865 11.9805 0.99939 12.2364 0.99939 12.4969C0.99939 12.7574 1.06865 13.0132 1.20006 13.2381C1.33489 13.4721 1.52954 13.6659 1.76404 13.7998C1.99853 13.9337 2.26442 14.0028 2.53444 14H13.4657C13.7355 14.0026 14.0011 13.9334 14.2354 13.7995C14.4696 13.6656 14.6641 13.4719 14.7988 13.2381C14.9304 13.0133 14.9999 12.7575 15.0001 12.497C15.0003 12.2365 14.9313 11.9806 14.8001 11.7556ZM7.50006 6.49998C7.50006 6.36737 7.55274 6.24019 7.64651 6.14643C7.74027 6.05266 7.86745 5.99998 8.00006 5.99998C8.13267 5.99998 8.25985 6.05266 8.35361 6.14643C8.44738 6.24019 8.50006 6.36737 8.50006 6.49998V8.99998C8.50006 9.13259 8.44738 9.25977 8.35361 9.35353C8.25985 9.4473 8.13267 9.49998 8.00006 9.49998C7.86745 9.49998 7.74027 9.4473 7.64651 9.35353C7.55274 9.25977 7.50006 9.13259 7.50006 8.99998V6.49998ZM8.00006 12C7.85172 12 7.70672 11.956 7.58338 11.8736C7.46005 11.7912 7.36392 11.674 7.30715 11.537C7.25038 11.3999 7.23553 11.2491 7.26447 11.1037C7.29341 10.9582 7.36484 10.8245 7.46973 10.7197C7.57462 10.6148 7.70826 10.5433 7.85374 10.5144C7.99923 10.4855 8.15003 10.5003 8.28707 10.5571C8.42412 10.6138 8.54125 10.71 8.62366 10.8333C8.70607 10.9566 8.75006 11.1016 8.75006 11.25C8.75006 11.4489 8.67104 11.6397 8.53039 11.7803C8.38974 11.921 8.19897 12 8.00006 12Z" fill="#E03B24" />
    </svg>
  )
}

const LowRiskIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M13 2.5H3C2.73478 2.5 2.48043 2.60536 2.29289 2.79289C2.10536 2.98043 2 3.23478 2 3.5V7C2 10.295 3.595 12.2919 4.93313 13.3869C6.37437 14.5656 7.80813 14.9656 7.87063 14.9825C7.95656 15.0059 8.04719 15.0059 8.13313 14.9825C8.19563 14.9656 9.6275 14.5656 11.0706 13.3869C12.405 12.2919 14 10.295 14 7V3.5C14 3.23478 13.8946 2.98043 13.7071 2.79289C13.5196 2.60536 13.2652 2.5 13 2.5ZM10.855 6.85375L7.355 10.3538C7.30856 10.4002 7.25342 10.4371 7.19272 10.4623C7.13202 10.4874 7.06696 10.5004 7.00125 10.5004C6.93554 10.5004 6.87048 10.4874 6.80978 10.4623C6.74908 10.4371 6.69394 10.4002 6.6475 10.3538L5.1475 8.85375C5.05368 8.75993 5.00097 8.63268 5.00097 8.5C5.00097 8.36732 5.05368 8.24007 5.1475 8.14625C5.24132 8.05243 5.36857 7.99972 5.50125 7.99972C5.63393 7.99972 5.76118 8.05243 5.855 8.14625L7 9.29313L10.1462 6.14625C10.1927 6.09979 10.2479 6.06294 10.3086 6.0378C10.3692 6.01266 10.4343 5.99972 10.5 5.99972C10.5657 5.99972 10.6308 6.01266 10.6914 6.0378C10.7521 6.06294 10.8073 6.09979 10.8538 6.14625C10.9002 6.1927 10.9371 6.24786 10.9622 6.30855C10.9873 6.36925 11.0003 6.4343 11.0003 6.5C11.0003 6.5657 10.9873 6.63075 10.9622 6.69145C10.9371 6.75214 10.9002 6.8073 10.8538 6.85375H10.855Z" fill="#37B450" />
    </svg>
  )
}

const Row = ({ data }) => {
  const isMountedRef = useRef(true);

  const setRecordToEdit = useEmsOfficeStore((state) => state.setRecordToEdit);
  const setIsAddEmsOfficeModalOpen = useEmsOfficeStore((state) => state.setIsAddEmsOfficeModalOpen);

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const dropDownOptions = [
    {
      text: "Edit",
      type: "normal",
      onClick: () => {
        setRecordToEdit(data)
        setIsAddEmsOfficeModalOpen(true);
      },
    },
  ];

  return (
    <>
      <tr className={styles.tbodyRow} >
        <td className={styles.td} >
        </td>
        <td className={styles.td} >
          {data?.id}
        </td>
        <td className={styles.td} >
          {data?.office_id}
        </td>
        <td className={styles.td} >
          {data?.name || '-'}
        </td>
        <td className={styles.td} >
          <div className={styles.flex} >
            {data.risk_type ? (
              <>
                {data.risk_type === 'high_risk' ? (
                  <HighRiskIcon />
                ) : (
                  <LowRiskIcon />
                )}
                <span>
                  {data.risk_type?.replace("_", " ")}
                </span>
              </>
            ) : (
              <>
                <span>-</span>
              </>
            )}
          </div>
        </td>
        <td className={styles.td} >
          <DropDown options={dropDownOptions} >
            <KebabIcon />
          </DropDown>
        </td>
      </tr>
    </>
  )
}

export default Row;